export default class UserFullnameDto {
	readonly firstName!: string;
	readonly lastName!: string;
}
